import { useSelectedOrganization } from './useSelectedOrganization';
import { TimezoneNames } from '../constants/timezones';
import { convertTimezoneEnumToName } from '../helpers/timeFormatter';
import { TimezoneSetting } from '../models/graphql';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { parse } from 'date-fns';
import { useCallback, useMemo } from 'react';

export const useWorkspaceTime = () => {
  const { selectedWorkspace } = useSelectedOrganization();

  const timezoneName: TimezoneNames = useMemo(
    () => convertTimezoneEnumToName(selectedWorkspace?.timezone || TimezoneSetting.UTC) || TimezoneNames.UTC,
    [selectedWorkspace]
  );

  const convertUtcTimeToWorkspaceTime = useCallback(
    (refDate = new Date()): Date => {
      return utcToZonedTime(refDate, timezoneName);
    },
    [timezoneName]
  );

  const parseDateInWorkspaceTime = useCallback(
    (dateString: string, formatString: string): Date => {
      // Parse the date string into a Date object in UTC
      const parsedDate = parse(dateString, formatString, new Date());

      // Convert the parsed date to the specified timezone
      return zonedTimeToUtc(parsedDate, timezoneName);
    },
    [timezoneName]
  );

  return useMemo(
    () => ({ convertUtcTimeToWorkspaceTime, parseDateInWorkspaceTime, timezoneName }),
    [convertUtcTimeToWorkspaceTime, parseDateInWorkspaceTime, timezoneName]
  );
};
